module.exports = __webpack_public_path__ + "static/media/Logo.8612c4f9.png";